// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.progress{
    position: fixed;
    right: 5rem;
    bottom: 3rem;
    height: 50px;
    width: 50px;
    z-index: 3;
    display: grid;
    place-items: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all 400ms linear;
    animation: translationX 400ms linear;
    z-index: 50;
}

@keyframes translationX{
    0%{
        transform:translateX(45px);
    }
    100%{
        transform:translateX(0px);
    }
}

.progress:hover{
    transform:scale(1.1);

}

.ProgressValue{
    display: block;
    height: calc(87%);
    width: calc(87%);
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-size: 1.2rem;
    z-index: 4;
}
.onHideValue{
    display: block;
    height: calc(87%);
    width: calc(87%);
    border-radius: 50%;
    display: grid;
    place-items: center;
    font-size: 1.2rem;
    z-index: 4;
    transition: all 400ms linear;
    animation: hideX 1s linear;
    opacity: 0;

}

.onHidePRogress{
    position: fixed;
    right: 3rem;
    bottom: 3rem;
    height: 50px;
    width: 50px;
    z-index: 3;
    display: grid;
    place-items: center;
    border-radius: 50%;
    cursor: pointer;
    transition: all 400ms linear;
    animation: hideX 400ms linear;
    opacity: 0;
}

@keyframes hideX{
    0%{
        transform:translateX(0px);
        opacity: 100;
    }
    100%{
        transform:translateX(45px);
        opacity: 0;

    }
}`, "",{"version":3,"sources":["webpack://./src/Components/ScrollProgress/ScrollProgress.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI;QACI,0BAA0B;IAC9B;IACA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,oBAAoB;;AAExB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,UAAU;IACV,4BAA4B;IAC5B,0BAA0B;IAC1B,UAAU;;AAEd;;AAEA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,4BAA4B;IAC5B,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI;QACI,yBAAyB;QACzB,YAAY;IAChB;IACA;QACI,0BAA0B;QAC1B,UAAU;;IAEd;AACJ","sourcesContent":[".progress{\n    position: fixed;\n    right: 5rem;\n    bottom: 3rem;\n    height: 50px;\n    width: 50px;\n    z-index: 3;\n    display: grid;\n    place-items: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 400ms linear;\n    animation: translationX 400ms linear;\n    z-index: 50;\n}\n\n@keyframes translationX{\n    0%{\n        transform:translateX(45px);\n    }\n    100%{\n        transform:translateX(0px);\n    }\n}\n\n.progress:hover{\n    transform:scale(1.1);\n\n}\n\n.ProgressValue{\n    display: block;\n    height: calc(87%);\n    width: calc(87%);\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    font-size: 1.2rem;\n    z-index: 4;\n}\n.onHideValue{\n    display: block;\n    height: calc(87%);\n    width: calc(87%);\n    border-radius: 50%;\n    display: grid;\n    place-items: center;\n    font-size: 1.2rem;\n    z-index: 4;\n    transition: all 400ms linear;\n    animation: hideX 1s linear;\n    opacity: 0;\n\n}\n\n.onHidePRogress{\n    position: fixed;\n    right: 3rem;\n    bottom: 3rem;\n    height: 50px;\n    width: 50px;\n    z-index: 3;\n    display: grid;\n    place-items: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: all 400ms linear;\n    animation: hideX 400ms linear;\n    opacity: 0;\n}\n\n@keyframes hideX{\n    0%{\n        transform:translateX(0px);\n        opacity: 100;\n    }\n    100%{\n        transform:translateX(45px);\n        opacity: 0;\n\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
